import React from 'react';
import AuditLogComponent from '../../../components/common/AuditLogComponent';

const AuditLogTab = ({ companyId, auditLogs = [] }) => {
  return <AuditLogComponent auditLogs={auditLogs} title="Company Audit Log" />;
};

export default AuditLogTab;
